/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.rest.client.internal

import io.ktor.util.InternalAPI
import io.ktor.util.decodeBase64String
import io.ktor.util.encodeBase64

actual object Base64 {
    // TODO [#136]: Don't use internal method for encoding
    @OptIn(InternalAPI::class)
    actual fun decode(string: String) = string.decodeBase64String()

    // TODO [#136]: Don't use internal method for encoding
    @OptIn(InternalAPI::class)
    actual fun encode(string: String) = string.encodeBase64()
}
